export const CREATE_INVOICE = "CREATE_INVOICE";
export const CREATE_INVOICE_SUCCESS = "CREATE_INVOICE_SUCCESS";
export const CREATE_INVOICE_ERROR = "CREATE_INVOICE_ERROR";

export const INVOICE_GET_ALL = "INVOICE_GET_ALL";
export const INVOICE_GET_ALL_SUCCESS = "INVOICE_GET_ALL_SUCCESS";
export const INVOICE_GET_ALL_ERROR = "INVOICE_GET_ALL_ERROR";

export const INVOICE_GET_BY_ID = "INVOICE_GET_BY_ID";
export const INVOICE_GET_BY_ID_SUCCESS = "INVOICE_GET_BY_ID_SUCCESS";
export const INVOICE_GET_BY_ID_ERROR = "INVOICE_GET_BY_ID_ERROR";

export const CLEAR_INVOICE_DATA = "CLEAR_INVOICE_DATA";
